import address from 'plugins/i18n/entity/address.en.ts'
import role from 'plugins/i18n/entity/role.en.ts'

const person = {
	name: 'Person | Persons',
	icon: 'fas fa-user | fas fa-users',
	fields: {
		hp_id: 'ID',
		lastname: 'Name',
		address: {
			...address.fields,
		},
		role: {
			...role.fields,
		},
		user_id: 'Account',
		user: {
			tos: ' ',
			email: 'Email',
		},
		person: {
			lastname: '@:entity.person.fields.lastname',
			user_id: 'Account',
		},
		unit: {
			position: '@:entity.unit.fields.position',
		},
		started_at: '@:entity.role.fields.started_at',
		ended_at: '@:entity.role.fields.ended_at',
	},
}

export default person
